import React, {memo, useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'antd';
import SelectElementCmp from '@/utils/SelectElementCmp';
import ClientsEstablishmentApiService from '@/modules/clients/services/ClientsEstablishmentApiService';
import { useTranslation } from 'react-i18next';

const SelectEstablishment = ({ value, onChange, setEstablishments, form, ...props }) => {
  const {t} = useTranslation('registers');

  const currentValue = useMemo(() => {
    return Array.isArray(value) ? value.map(v => v._id || v) : undefined;
  }, [value]);

  const handleOnChange = useCallback((val) => {
    setEstablishments(val);
    onChange(val);
    if (!val || val.length === 0)
      form.setFieldsValue({areas: []});
  }, [form, onChange, setEstablishments]);

  return (
    <SelectElementCmp
      queryKey={'register-establishment-select'}
      service={ClientsEstablishmentApiService}
      includeValue={''}
      value={currentValue}
      onChange={handleOnChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      nameToShow={'name'}
      mode="multiple"
      allOption={{ show: true, label: t('selectAllEstablishments'), value: 'all', excludeValueFromFilters: true }}
      {...props}
      defaultValue={() => []}
      showDefaultValue
    />
  );
};

SelectEstablishment.propTypes = {
  value: PropTypes.string || PropTypes.object,
  onChange: PropTypes.func,
  filters: PropTypes.object,
  setEstablishments: PropTypes.func,
  form: PropTypes.object,
};
SelectEstablishment.defaultProps = {
  entity: {},
};

export default memo(SelectEstablishment);

const EstablishmentView = ({entity}) => {

  return (
    <div className="w-full my-1">
      {entity?.establishments?.length > 0
        ? (
          <div className="flex items-center justify-start flex-wrap gap-3">
            {entity?.establishments.map(v => (
              <Tag key={v?._id}>{v.name}</Tag>
            ))}
          </div>
        ) : 'N/A'}
    </div>
  );
};

EstablishmentView.propTypes = {
  value: PropTypes.array,
  entity: PropTypes.object,
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {Array} value this is the value of the dataIndex of the table
 * @param {Object} form this is the value of the dataIndex of the table
 * @param {Object} entity this is the value of the dataIndex of the table
 * */
export const renderEstablishment = (value, form, entity) => {
  return (
    <EstablishmentView value={value} entity={entity}/>
  );
};
